// extracted by mini-css-extract-plugin
export default {"setPasswordBox":"SetPassword_setPasswordBox__vpccG"};